import { useMemo, useState } from 'react';

type UseToggleResponse = [boolean, () => void, () => void, (value: boolean) => void];

const useToggle = (isDefaultToggled: boolean = false): UseToggleResponse => {
    const [isToggled, setIsToggled] = useState<boolean>(isDefaultToggled);

    return useMemo(
        (): UseToggleResponse => {
            const set = (): void => setIsToggled(true);
            const unset = (): void => setIsToggled(false);

            return [isToggled, set, unset, setIsToggled];
        },
        [isToggled, setIsToggled],
    );
};

export default useToggle;
